// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
/**
 * A no-op implementation of BinaryFormat to be used when tracing is disabled.
 */
var NoOpBinaryFormat = /** @class */ (function () {
    function NoOpBinaryFormat() {
    }
    /** Serialize the given SpanContext to a buffer */
    NoOpBinaryFormat.prototype.toBytes = function (_spanContext) {
        return new ArrayBuffer(0);
    };
    /**
     * Deserialize a SpanContext from binary encoding.
     * Returns null if the buffer does not contain a valid SpanContext.
     */
    NoOpBinaryFormat.prototype.fromBytes = function (_buffer) {
        return null;
    };
    return NoOpBinaryFormat;
}());
export { NoOpBinaryFormat };
//# sourceMappingURL=noOpBinaryFormat.js.map